import { Navigate, Outlet } from 'react-router-dom';
import { useFinancePnlAccess } from '@/hooks/useBudgetControl';
import { WinclapLoader } from '@/components/ui/winclap-loader';

/**
 * Gate de Finance → Control Presupuestario. El acceso lo resuelve el governance
 * FINANCE_PNL_GOVERNANCE (Juan Cruz + admins; viewers por persona o team): sin
 * el gate, quien no tiene acceso entraría y vería el dashboard vacío — el
 * FORBIDDEN silencioso que prohíbe la política de roles del repo.
 */
export function FinancePnlProtectedRoute() {
  const { data: access, isLoading } = useFinancePnlAccess();
  if (isLoading) {
    return (
      <div className="flex h-64 items-center justify-center">
        <WinclapLoader size={48} className="text-foreground/25" />
      </div>
    );
  }
  if (!access?.canView) return <Navigate to="/dashboard" replace />;
  return <Outlet />;
}
